import React from "react";
import { Box, Typography } from "@mui/material";

const StatItem = ({
  label,
  amount,
  percentage,
  isNegative = false,
  suffix = "",
  hidePercentage = false,
}) => (
  <Box
    sx={{
      marginBottom: "1px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 4px",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        transform: "translateY(-1px)",
      },
    }}
  >
    <Box
      sx={{
        width: "100%",
        textAlign: "left",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.9rem",
          fontWeight: 600,
          color: "#2c3e50",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </Typography>
    </Box>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        width: "50%",
      }}
    >
      <Typography
        sx={{
          fontSize: "1.1rem",
          fontWeight: 700,
          color: isNegative ? "#e74c3c" : "#27ae60",
          marginBottom: "4px",
        }}
      >
        {amount === null || amount === undefined || Number.isNaN(amount)
          ? "—"
          : typeof amount === "number" && !suffix
          ? amount.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })
          : `${Math.round(amount).toLocaleString()}${suffix}`}
      </Typography>
      {!hidePercentage && typeof percentage === "number" && (
        <Typography
          sx={{
            color: isNegative ? "#e74c3c" : "#7f8c8d",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {percentage.toFixed(2)}% of AUM
        </Typography>
      )}
    </Box>
  </Box>
);

export default StatItem;
